export type DayOfWeekEnum = 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY';

export const DayOfWeekEnumValues = {
    Monday: 'MONDAY' as DayOfWeekEnum,
    Tuesday: 'TUESDAY' as DayOfWeekEnum,
    Wednesday: 'WEDNESDAY' as DayOfWeekEnum,
    Thursday: 'THURSDAY' as DayOfWeekEnum,
    Friday: 'FRIDAY' as DayOfWeekEnum,
    Saturday: 'SATURDAY' as DayOfWeekEnum,
    Sunday: 'SUNDAY' as DayOfWeekEnum,
};
